import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import newLogo from "../../assets/images/newLogo.png";

const FinalModal = ({ showFinal, handleCloseFinal, handleLogout }) => {
  // The user should not have to click anything to actually be logged out —
  // auto-redirect a few seconds after this appears so the message is still
  // readable, but the session ends whether or not the click lands.
  useEffect(() => {
    if (!showFinal) return;
    const timeout = setTimeout(() => {
      handleLogout();
    }, 4000);
    return () => clearTimeout(timeout);
  }, [showFinal, handleLogout]);

  return (
    <div>
      <Modal
        show={showFinal}
        onHide={() => {
          handleCloseFinal();
          handleLogout();
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div className="mb-3">
              <img
                src={newLogo}
                alt="switch logo"
                style={{ width: "30%", textAlign: "center" }}
              />
            </div>
            <div className="mb-2">
              <h4 className="sec-header text-body mb-3 px-sm-5 mx-sm-5">
                You have been inactive
              </h4>
              <p className="ftsz-regular">Your account has been logged out.</p>
            </div>

            <div className="mx-5 py-4">
              <button
                type="button"
                className="btn loginBtn btn-sm btn-block"
                onClick={handleLogout}
              >
                Login
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FinalModal;
